import gql from 'graphql-tag';

// @TODO might need to make this more generic with fragments when re-using
export const removeScheduledSessionMutation = gql`
  mutation RemoveScheduledSession($id: ID!, $removeReferences: [ID!]) {
    removeScheduledSession(id: $id, removeReferences: $removeReferences) {
      ... on RemoveObjectResultResponse {
        id
      }
      ... on RemoveObjectConfirmationResponse {
        references { id, type, title, canBeSafelyRemoved }
      }
    }
  }
`;